import React, { Component} from 'react'
import ModalWrapper from './ModalWrapper'
import Button from '../uiKit/Button'
import {getQuestionBodyLabel} from '../../utils/getQuestionBodyLabel'
import {getConfirmModalSettings} from '../../utils/getConfirmModalSettings'
import FeatureModalSelectControl from '../featureModals/FeatureModalSelectControl'
import FeatureModalSelectControlGroup from '../featureModals/FeatureModalSelectControlGroup'
import {saveSettingToLocalStorage} from '../../utils/saveSettingToLocalStorage'


class ConfirmModal extends Component {
	
	constructor() {
		super()
		this.handleAccept=this.handleAccept.bind(this)
		this.setConfirmModalSetting=this.setConfirmModalSetting.bind(this)

		const confirmModalSettings=getConfirmModalSettings()

		this.state={
			buttonDisabled:false,
			confirmModalSettings:confirmModalSettings,
			confirmModalCheckboxChecked:false
		}
	}



	setConfirmModalSetting(setting,value){
		saveSettingToLocalStorage('confirmModalSettings',setting,value)
		this.setState({confirmModalCheckboxChecked:true})
	}




	UNSAFE_componentWillMount() {
		if(this.props.actionType==='moveFromSharedRepo' && !this.state.confirmModalSettings.showMoveFromSharedRepoModal){
			this.props.accept()
		}
		else if(this.props.actionType==='trash' && !this.state.confirmModalSettings.showSendToTrashModal){
			this.props.accept()
		}
		else if(this.props.actionType==='archive' && !this.state.confirmModalSettings.showArchiveModal){
			this.props.accept()
		}
		else if(this.props.actionType==='leave' && !this.state.confirmModalSettings.showLeaveRepoModal){
			this.props.accept()
		}
		else if(this.props.actionType==='archiveRepoItem' && !this.state.confirmModalSettings.showArchiveRepoItemModal){
			this.props.accept(this.props.confirmItem)
		}
		
	}

	

	handleAccept(items){
		this.setState({buttonDisabled:true})
		this.props.accept(items)
 
	}


	render() {
		const {buttonDisabled	}=this.state
		const {confirmItem,actionType}=this.props


		
		if(actionType==='trash' && this.state.confirmModalSettings.showSendToTrashModal)

		{
			return (
				<div className='confirmModal-modal'>
					<ModalWrapper
						{...this.props}
						title='Send to Trash'						
						showModalHeader={false}
					>
						
						<div className='confirmModal'>
							<div className='confirmModal-h1'>
								Are you sure you want to <br/><b>send this to trash?</b>
							</div>
							<div className='confirmModal-h2'>
								You can restore trashed items at any point.
							</div>
							<div className='confirmModal-h2'>
								You will be directed back Home if you send this trash.
							</div>							

							<FeatureModalSelectControlGroup>
								<FeatureModalSelectControl onClick={()=>{this.setConfirmModalSetting('showSendToTrashModal',false)}}  checked={this.state.confirmModalCheckboxChecked}checkbox label='Do not show this warning again' />
							</FeatureModalSelectControlGroup>						 
							
							<div className='confirmModal-buttonSet'>
								<Button name='confirmModalConfirm' disabled={buttonDisabled} label='Yes, send to Trash' onClickFunction={this.handleAccept}/>
								<Button name='confirmModalCancel' label='Cancel'  onClickFunction={() =>{this.props.hideModal()}}/>
							</div>
						</div>	
					</ModalWrapper>
				</div>
			)
		}

		else if(actionType==='batchArchive'){

			return (
				<div className='confirmModal-modal has--dynamicHeight'>
					<ModalWrapper
						{...this.props}
						title='Send to Trash'
						showModalHeader={false}
					>
			
						<div className='confirmModal'>	
							
							<div className='confirmModal-h1'>
								Are you sure you want to <b>send the following items to trash?</b>
							</div>

							<div className='confirmModal-dynamicItemList'>
								{Object.keys(this.props.confirmItem).map((key,index) =>{
									const item=this.props.confirmItem[key]
									return(
									 <div className='confirmModal-item' key={index}>{item.name || getQuestionBodyLabel(item)}</div>              
								)})}						
							</div>																				
							

							<div className='confirmModal-buttonSet'>
								<Button name='confirmModalConfirm' disabled={buttonDisabled} label={`Yes, send ${Object.keys(this.props.confirmItem).length} items to trash`}  onClickFunction={this.handleAccept}/>
								<Button name='confirmModalCancel' label='Cancel'  onClickFunction={() =>{this.props.hideModal()}}/>
							</div>
						</div>
					</ModalWrapper>
				</div>
			)
		}


		else if(actionType==='archive' && this.state.confirmModalSettings.showArchiveModal){

			let sectionName			

			if(this.props.confirmItem && this.props.confirmItem.name.length < 25){
				sectionName = this.props.confirmItem.name				
			}
			else if(this.props.confirmItem && this.props.confirmItem.name.length >= 25){	
				sectionName = this.props.confirmItem.name.substring(25,0) + '...'					
			}


			return (
				<div className='confirmModal-modal'>
					<ModalWrapper
						{...this.props}
						title={`Archive ${this.props.confirmItem.name}`}						
						showModalHeader={false}
					>
						<div className='confirmModal'>					
							<div className='confirmModal-h1'>
								Are you sure you want to archive <b>{sectionName}?</b>
							</div>							
							<div className='confirmModal-h2'>
								All student data and class history will be stored safely.
							</div>
							<div className='confirmModal-h2'>
								You can unarchive any classes, or permanently delete them, by clicking on 'Edit' next to Your Classes on the left-hand navigation.
							</div>

							<FeatureModalSelectControlGroup>
								<FeatureModalSelectControl onClick={()=>{this.setConfirmModalSetting('showArchiveModal',false)}}  checked={this.state.confirmModalCheckboxChecked} checkbox label='Do not show this warning again' />
							</FeatureModalSelectControlGroup>						 
							
							<div className='confirmModal-buttonSet'>
								<Button name='confirmModalConfirm' disabled={buttonDisabled} label= 'Yes, archive Class' onClickFunction={this.handleAccept}/>
								<Button name='confirmModalCancel' label='Cancel'  onClickFunction={() =>{this.props.hideModal()}}/>
							</div>
							
						</div>
					</ModalWrapper>
				</div>
			)
		}

		else if(actionType==='emptyTrash'){


		 return (
				<div className='confirmModal-modal'>
					<ModalWrapper
						{...this.props}							
						showModalHeader={false}
					>
						<div className='confirmModal'>           
							<div className='confirmModal-h1'>
								Are you sure you want to <b>empty your Trash?</b>
							</div>
							<div className='confirmModal-h2'>
								Everything in your trash will be permanently deleted.
							</div>
							<div className='confirmModal-h2'>
								This cannot be undone.
							</div>

							<div className='confirmModal-buttonSet'>
								<Button name='confirmModalConfirm' disabled={buttonDisabled} label= 'Yes, I want to empty my Trash' onClickFunction={this.handleAccept}/>
								<Button name='confirmModalCancel' label='Cancel'  onClickFunction={() =>{this.props.hideModal()}}/>
							</div>

						</div>
					</ModalWrapper>
				</div>
			)
		}
		else if(actionType==='leave' && this.state.confirmModalSettings.showLeaveRepoModal){

			let repoName

			if(this.props.confirmItem && this.props.confirmItem.name.length < 40){
				repoName = this.props.confirmItem.name				
			}
			else if(this.props.confirmItem && this.props.confirmItem.name.length >= 40){	
				repoName = this.props.confirmItem.name.substring(37,0) + '...'				
			}


		 return (
				<div className='confirmModal-modal'>
					<ModalWrapper
						{...this.props}
						
						showModalHeader={false}
					>
						<div className='confirmModal'>           
							<div className='confirmModal-h1'>
								Are you sure you want to <b>leave {repoName}?</b>
							</div>							
							<div className='confirmModal-h2'>
								To regain access to this pack, you will need to be re-invited by a member.
							</div>							

							<FeatureModalSelectControlGroup>
								<FeatureModalSelectControl onClick={()=>{this.setConfirmModalSetting('showLeaveRepoModal',false)}}  checked={this.state.confirmModalCheckboxChecked} checkbox label='Do not show this warning again' />
							</FeatureModalSelectControlGroup>						 

							<div className='confirmModal-buttonSet'>
								<Button name='confirmModalConfirm' disabled={buttonDisabled} label= 'Yes, I want to leave' onClickFunction={this.handleAccept}/>
								<Button name='confirmModalCancel' label='Cancel'  onClickFunction={() =>{this.props.hideModal()}}/>
							</div>

						</div>
					</ModalWrapper>
				</div>
			)
		}

		else if(actionType==='archiveRepoItem' && this.state.confirmModalSettings.showArchiveRepoItemModal){


			let itemName // original
			let itemLabel // cutdown if too long

			if(this.props.confirmItem && this.props.confirmItem.name){
				itemName = this.props.confirmItem.name
			}
			else if(this.props.confirmItem && this.props.confirmItem.body){
				itemName = this.props.confirmItem.body	
			}
			
			if(itemName && itemName.length < 45){
				itemLabel = itemName
			}
			else if(itemName && itemName.length >= 45){	
				itemLabel = itemName.substring(45,0) + '...'					
			}


		 return (
				<div className='confirmModal-modal'>
					<ModalWrapper
						{...this.props}												
						showModalHeader={false}
					>
						<div className='confirmModal'>           
							<div className='confirmModal-h1'>
								Are you sure you want to <b>send {itemLabel} to trash?</b>
							</div>
							<div className='confirmModal-h2'>
								If you send this item to trash, it will be removed from every members queue.
							</div>
							    
							<FeatureModalSelectControlGroup>
								<FeatureModalSelectControl  onClick={()=>{this.setConfirmModalSetting('showArchiveRepoItemModal',false)}}  checked={this.state.confirmModalCheckboxChecked} checkbox label='Do not show this warning again' />
							</FeatureModalSelectControlGroup>						 

							<div className='confirmModal-buttonSet'>
								<Button name='confirmModalConfirm' disabled={buttonDisabled} label= 'Yes, I want to send it to trash' onClickFunction={()=>{this.handleAccept(this.props.confirmItem)}} />
								<Button name='confirmModalCancel' label='Cancel'  onClickFunction={() =>{this.props.hideModal()}}/>
							</div>
						</div>
					</ModalWrapper>
				</div>
			)
		}

		else if(actionType==='moveFromSharedRepo' && this.state.confirmModalSettings.showMoveFromSharedRepoModal){
			
			let multipleItems = false
			const numberOfItems=Object.keys(confirmItem).length

			if(numberOfItems > 1){
				multipleItems = true
			}

			console.log(numberOfItems)
			const firstItem=confirmItem[Object.keys(confirmItem)[0]]

			let itemName
			let itemLabel

			if(!multipleItems && !firstItem.body){
				itemName = firstItem.name

			}
			if(!multipleItems && firstItem.body){
				itemName = firstItem.body
			}

			if(!multipleItems && itemName && itemName.length < 45){
				itemLabel = itemName
			}
			else if(!multipleItems && itemName && itemName.length >= 45){	
				itemLabel = itemName.substring(45,0) + '...'					
			}

			let buttonLabel

			if(multipleItems){
				buttonLabel = 'Yes, I want to move them'
			}
			if(!multipleItems){
				buttonLabel = 'Yes, I want to move it'
			}


		 return (
				<div className='confirmModal-modal'>
					<ModalWrapper
						{...this.props}						
						showModalHeader={false}
					>
						<div className='confirmModal'>           

							{!multipleItems &&
								<React.Fragment>
									<div className='confirmModal-h1'>
										Are you sure you want to move <b>{itemLabel}</b> out of this shared pack?
									</div>								
									<div className='confirmModal-h2'>
										If you move this item, members of the shared pack will lose access to it.
									</div>
								</React.Fragment>						
							}
							
							{multipleItems &&
								<React.Fragment>
									<div className='confirmModal-h1'>
										Are you sure you want to move these items out of a shared pack?
									</div>						
									<div className='confirmModal-h2'>
										If you move these items, members of the current pack will lose access to them.
									</div>
								</React.Fragment>
							}

							<FeatureModalSelectControlGroup>
								<FeatureModalSelectControl  onClick={()=>{this.setConfirmModalSetting('showMoveFromSharedRepoModal',false)}}  checked={this.state.confirmModalCheckboxChecked} checkbox label='Do not show this warning again' />
							</FeatureModalSelectControlGroup>	

							<div className='confirmModal-buttonSet'>
								<Button name='confirmModalConfirm' disabled={buttonDisabled} label={buttonLabel} onClickFunction={()=>{this.handleAccept()}} />
								<Button name='confirmModalCancel' label='Cancel'  onClickFunction={() =>{this.props.hideModal()}}/>
							</div>												

						</div>

					</ModalWrapper>
				</div>
			)
		}

		else if(actionType==='delete' && confirmItem.joined){


			let itemName // original
			let itemLabel // cutdown if too long

			if(this.props.confirmItem && this.props.confirmItem.name){
				itemName = confirmItem.name
			}
			
			if(itemName && itemName.length < 45){
				itemLabel = confirmItem.name
			}
			else if(itemName && itemName.length >= 45){	
				itemLabel = confirmItem.name.substring(45,0) + '...'					
			}


		 return (
				<div className='confirmModal-modal'>
					<ModalWrapper
						{...this.props}						
						showModalHeader={false}
					>
						<div className='confirmModal'>           
							<div className='confirmModal-h1'>
								Are you sure you want to <b>delete {itemLabel}?</b>
							</div>
							<div className='confirmModal-h2'>
								The pack and its contents will be permanently deleted.
							</div>
							<div className='confirmModal-h2'>
								This cannot be undone.
							</div>
							    							
							<div className='confirmModal-buttonSet'>
								<Button name='confirmModalConfirm' disabled={buttonDisabled} label= 'Yes, I want to delete it' onClickFunction={()=>{this.handleAccept(this.props.confirmItem)}} />
								<Button name='confirmModalCancel' label='Cancel'  onClickFunction={() =>{this.props.hideModal()}}/>
							</div>
						</div>
					</ModalWrapper>
				</div>
			)
		}

		else if(actionType==='delete' && !confirmItem.joined){
			let itemType=''
			let itemTitle // original

			if(confirmItem.ancestors){
				itemType = 'Folder'
				itemTitle=confirmItem.name
			}			
			else if(confirmItem.name){
				itemType = 'Set'
				itemTitle=confirmItem.name
			}
			else if(confirmItem.choices){
				itemType = 'Question'
				itemTitle=getQuestionBodyLabel(confirmItem)
			}
			else if(confirmItem.firstName){
				itemType = 'Student'
				itemTitle= confirmItem.displayName
			}
			else if(confirmItem.snapshot){    
				itemType = 'Report'  
				itemTitle = confirmItem.snapshot.name || getQuestionBodyLabel(confirmItem.snapshot)
			}

		
			let itemLabel = itemTitle
			
			if(itemTitle && itemTitle.length >= 60){	
				itemLabel = itemTitle.substring(60,0) + '...'					
			}





			return (
				<div className='confirmModal-modal'>
					<ModalWrapper
						{...this.props}						
						showModalHeader={false}
					>
						<div className='confirmModal'>           
							<div className='confirmModal-h1'>
								Are you sure you want to <b>delete {itemLabel}?</b>
							</div>							
							<div className='confirmModal-h2'>
								This cannot be undone.
							</div>
							    							
							<div className='confirmModal-buttonSet'>
								<Button name='confirmModalConfirm' disabled={buttonDisabled} label={`Permanently Delete ${itemType}`} size='xLarge' color='red' onClickFunction={()=>{this.handleAccept(this.props.confirmItem)}}/>
								<Button name='confirmModalCancel' label='Cancel'  onClickFunction={() =>{this.props.hideModal()}}/>
							</div>
						</div>

					</ModalWrapper>
				</div>
			)
		}
		else{
			return null
		}
	}
}

export default ConfirmModal


// WEBPACK FOOTER //
// ./src/components/modals/ConfirmModal.js